import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useI18n } from "../context/I18nContext";
import { IMAGES } from "../lib/images";
import { Overline, Reveal } from "./Reveal";

export default function Edouard() {
  const { t } = useI18n();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-7%", "7%"]);

  return (
    <section id="edouard" data-testid="edouard-section" className="bg-cream py-24 text-charcoal md:py-36">
      <div className="mx-auto grid max-w-7xl gap-14 px-5 md:px-10 lg:grid-cols-12">
        <div className="lg:col-span-6">
          <Reveal y={40}>
            <div ref={ref} className="overflow-hidden">
              <motion.img
                src={IMAGES.edouardPortrait}
                alt={t.edouard.imageAlt}
                loading="lazy"
                style={{ y }}
                className="aspect-[3/2] w-full scale-[1.16] object-cover"
              />
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-4 text-[11px] uppercase tracking-[0.22em] text-stonekw">
              {t.edouard.photoCaption}
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-6">
          <Reveal>
            <Overline>{t.edouard.overline}</Overline>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-6 font-serif text-4xl md:text-5xl">{t.edouard.name}</h2>
          </Reveal>
          <Reveal delay={0.14}>
            <p className="mt-4 font-corm text-xl italic text-terra md:text-2xl">{t.edouard.subtitle}</p>
          </Reveal>
          <div className="mt-8 space-y-5">
            {t.edouard.bio.map((p, i) => (
              <Reveal key={i} delay={0.18 + 0.05 * i}>
                <p className={`leading-relaxed ${i === 0 ? "text-lg text-charcoal/85" : "text-charcoal/70"}`}>
                  {p}
                </p>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.3}>
            <p className="mt-9 border-l-2 border-terra pl-6 font-corm text-2xl italic leading-snug text-charcoal/90">
              {t.edouard.sign}
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
